import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LandingComponent } from './pages/landing/landing.component';

@NgModule({
    declarations: [LandingComponent],
    imports: [CommonModule, ReactiveFormsModule, RouterModule],
})
export class LandingModule {}
